export default "__VITE_ASSET__iy6Dl2Tx__"